import React, { useState } from 'react'
import './Portfolio.css'

const Portfolio = () => {
  const [bigCard] = useState([
    /*{
      image: require('../../assets/images/portfolio-flixcy-web.jpg'),
      title: 'Flixcy',
      description: 'Web application.',
      tech: 'React, Next.js, TypeScript.',
      url: 'https://flixcy.com/',
    },*/
    {
      image: require('../../assets/images/portfolio-grupo-minero-superior-web.jpg'),
      title: 'Grupo Minero Superior',
      description: 'Company website.',
      tech: 'React, HTML5, CSS, JavaScript.',
      url: 'https://grupominerosuperior.com/',
    },
    {
      image: require('../../assets/images/portfolio-comfama-magazine.jpg'),
      title: 'Comfama',
      description: 'Online Magazine.',
      tech: 'Next.js, React, HTML, Sass, TypeScript.',
      url: 'https://d3qcwili52gjl2.cloudfront.net/',
    },
    {
      image: require('../../assets/images/portfolio-luvania-web.jpg'),
      title: 'Luvania',
      description: 'Landing page.',
      tech: 'Next.js, React, HTML, Sass, JavaScript.',
      url: 'https://tratamientos-medicos-co.vercel.app/',
    },

    {
      image: require('../../assets/images/portfolio-laika-app.jpg'),
      title: 'Laika app',
      description: 'Mobile app.',
      tech: 'React Native, Flex, React Router Dom, JavaScript.',
      url: 'https://laika.com.co/city/bog/dog',
    },
    /*{
            image: require('../../assets/images/portfolio-softars-web.jpg'),
            title: 'SoftArs',
            description: 'Company website.',
            tech: 'React, HTML, Sass, Javascript.',
            url: 'http://softars.io/'
        },*/
    {
      image: require('../../assets/images/portfolio-lorusso-web.jpg'),
      title: 'T.S. Lorusso',
      description: 'Company website.',
      tech: 'HTML, CSS, JavaScript.',
      url: 'http://www.lorussonet.com/',
    },
    {
      image: require('../../assets/images/portfolio-equifax-web.jpg'),
      title: 'Equifax Ignite™',
      description: 'Demo page.',
      tech: 'HTML, CSS, JavaScript.',
      url: 'https://equifax-demo-zeta.vercel.app/',
    },
    {
      image: require('../../assets/images/portfolio-konvergy-web.jpg'),
      title: 'Konvergy',
      description: 'Demo page.',
      tech: 'Web design, HTML, CSS, JavaScript.',
      url: 'https://konvergy-web.vercel.app/',
    },
  ])

  const [smallCard] = useState([
    {
      image: require('../../assets/images/portfolio-kiero-web.jpg'),
      title: 'Kiero Marketplace',
      description: 'Online shop.',
      tech: 'React, HTML, Sass, JavaScript.',
      // url: 'https://kiero.co/'
    },
    {
      image: require('../../assets/images/portfolio-tigy-web.jpg'),
      title: 'Tigy web',
      description: 'Web app / Social network.',
      tech: 'React, HTML, React Router Dom, Sass, JavaScript.',
      // url: 'https://tigyweb.tigyapp.com/'
    },
    {
      image: require('../../assets/images/portfolio-hollywood-hel-web.jpg'),
      title: 'Hollywood heladeria',
      description: 'Demo page.',
      tech: 'Web design, WordPress, HTML, CSS, JavaScript.',
    },
    {
      image: require('../../assets/images/portfolio-mealtohome-web.jpg'),
      title: 'Delivery',
      description: 'Demo page.',
      tech: 'Web design, HTML, CSS, JavaScript.',
    },
  ])

  return (
    <div className="container" id="portfolio">
      <div className="portfolio content">
        <section className="portfolio__section">
          <h1>Portfolio</h1>
          <div className="portfolio__info big__card">
            {bigCard.map((data, key) => (
              <div className="porfolio__data box" key={key}>
                <img src={data.image} alt={data.title} />
                <div className="porfolio__data__text">
                  <h2>{data.title}</h2>
                  <p>{data.description}</p>
                  <p className="tech">
                    <span>{data.tech}</span>
                  </p>
                  {data.url ? (
                    <a href={data.url} target="_blank" rel="noopener noreferrer">
                      <p>View web</p>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="portfolio__info small__card">
            {smallCard.map((data, key) => (
              <div className="porfolio__data box" key={key}>
                <img src={data.image} alt={data.title} />
                <div className="porfolio__data__text">
                  <h3>{data.title}</h3>
                  <p>{data.description}</p>
                  <p className="tech">
                    <span>{data.tech}</span>
                  </p>
                  {data.url ? (
                    <a href={data.url} target="_blank" rel="noopener noreferrer">
                      <p>View web</p>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  )
}

export default Portfolio
